import apiConfig from '../../../apiConfig';

export type DateFlowTimeSlot = {
  time: string;
  available: boolean;
};

export const fetchAvailableTimesForDate = async (
  storeId: number,
  date: string,
): Promise<DateFlowTimeSlot[]> => {
  const url = new URL(`${apiConfig.baseURL}/api/customer-app/reservation/by-date/times`);
  url.searchParams.set('store_id', String(storeId));
  url.searchParams.set('date', date);

  const res = await fetch(url.toString(), { method: 'GET' });
  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new Error((data as any).error || 'Failed to fetch available times');
  }

  const data = (await res.json()) as { slots?: DateFlowTimeSlot[] };
  return Array.isArray(data.slots) ? data.slots : [];
};
